import productThinking from "./productThinking";
import research from "./research";
import userExperience from "./userExperience";
import userInterface from "./userInterface";
import communication from "./communication";

export default {
  productThinking,
  research,
  userExperience,
  userInterface,
  communication,
};
